import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "src/assets/logo-sac.svg";
import "./AuthLayout.css";

export default function AuthLayout({ children, action, className = "" }) {
  return (
    <div className={`partner-auth ${className}`}>
      <aside className="partner-auth-brand">
        <Link to="/" aria-label="SacGPT — Login"><Logo /></Link>
        <p>Seu atendimento não<br />dorme. Você sim.</p>
      </aside>
      <main className="partner-auth-main">
        <div className="partner-auth-action">{action}</div>
        <div className="partner-auth-form">{children}</div>
        <footer className="partner-auth-footer">
          <span>© {new Date().getFullYear()} SacGPT</span>
          <nav aria-label="Informações">
            <a href="https://sacgpt.com.br/termos">Termos</a>
            <a href="https://sacgpt.com.br/privacidade">Privacidade</a>
            <a href="mailto:contato@sacgpt.com.br">Ajuda</a>
          </nav>
        </footer>
      </main>
    </div>
  );
}
